import React from "react";
import { FileText, CalendarCheck, Sparkles, ScrollText } from "lucide-react";

const ICONS = [FileText, CalendarCheck, Sparkles, ScrollText];

export default function VedicHowItWorks({ title = "How booking works", subtitle, steps }) {
  return (
    <section className="bg-secondary/40 border-y border-border" data-testid="vedic-how-it-works">
      <div className="px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto py-14 lg:py-20">
        <div className="mb-10 text-center max-w-2xl mx-auto">
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-accent mb-3">Simple & Sacred</p>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-serif font-semibold tracking-tight">{title}</h2>
          {subtitle && <p className="mt-3 text-muted-foreground leading-relaxed">{subtitle}</p>}
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {steps.map((s, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <div key={s.title} data-testid={`hiw-step-${i}`} className="rounded-2xl bg-card border border-border p-6 text-center relative hover-lift">
                <span className="absolute top-4 right-4 font-serif text-3xl font-bold text-accent/20">{i + 1}</span>
                <span className="h-12 w-12 mx-auto grid place-items-center rounded-xl bg-gradient-to-br from-accent/20 to-primary/20 text-primary mb-4"><Icon className="h-6 w-6" /></span>
                <h3 className="font-serif text-lg font-semibold">{s.title}</h3>
                <p className="text-sm text-muted-foreground mt-1.5">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
